import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import Swal from "sweetalert2";

import axios from "../../../utils/axiosConfig";
import ModalBaseSm from "../modal-base-sm";
import FormModalReportePowerBi from "../../formsSolicitudes/formModalReportePowerBi";

const ModalReportesBI = ({ onClose, bitInsert, bitEdit, bitDelete }) => {
    const [data, setData] = useState([]);

    const [idEdit, setIdEdit] = useState(-1);
    const [selectedReporte, setSelectedReporte] = useState(null);
    const [modalEdicionOpen, setModalEdicionOpen] = useState(false);

    /* ------------------ Normalizadores ------------------ */
    const norm = (v) =>
        String(v ?? "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .trim()
            .toLowerCase();

    const toArray = (v) =>
        Array.isArray(v)
            ? v
            : String(v ?? "")
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean);

    /* ------------------ Cargar reportes ------------------ */
    const fetchReportes = async () => {
        try {
            const res = await axios.get(
                process.env.REACT_APP_SERVER + "/operaciones/getreportesbi",
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                }
            );

            if (res.data.success === false) {
                return;
            }

            const fetchedData = res.data.data || [];
            const userRole = res.data.rol;
            const userRoleNorm = norm(userRole);

            const filtered = fetchedData.filter((item) => {
                const rawRoles =
                    item.RolesAutorizadosIds ??
                    item.RolesIds ??
                    item.RolesAutorizados ??
                    item.roles_autorizados ??
                    "";

                const rolesListNorm = toArray(rawRoles).map(norm);
                if (!rolesListNorm.length) return false;

                return rolesListNorm.includes(userRoleNorm);
            });

            setData(filtered);
        } catch (error) {
            console.error("Error al obtener reportes BI:", error);
        }
    };

    /* ------------------ Acciones ------------------ */
    const onEditReport = (report) => {
        if (!bitEdit) {
            Swal.fire("Sin permisos", "No puedes editar reportes.", "info");
            return;
        }

        setIdEdit(report.Id_Reporte);
        setSelectedReporte(report);
        setModalEdicionOpen(true);
    };

    const handleNewReportOpen = () => {
        if (!bitInsert) {
            Swal.fire({
                title: "Información",
                text: "No tiene los permisos necesarios para crear reportes",
                icon: "info",
                showConfirmButton: false,
                timer: 3000,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
            return;
        }

        setIdEdit(-1);
        setSelectedReporte(null);
        setModalEdicionOpen(true);
    };

    const handleCloseModalEdicion = () => {
        setModalEdicionOpen(false);
        setIdEdit(-1);
        setSelectedReporte(null);
        fetchReportes(); // recargar lista
    };

    /* ------------------ Columnas tabla ------------------ */
    const columns = [
        {
            name: "Categoría",
            selector: (row) => row.ReportCategoria || "Sin categoría",
            sortable: true,
            wrap: true,
        },
        {
            name: "Nombre",
            selector: (row) => row.NombreReporte || "",
            sortable: true,
            wrap: true,
        },
        {
            name: "Descripción",
            selector: (row) => row.DescripcionReporte || "",
            sortable: false,
            wrap: true,
        },
        {
            name: "Acciones",
            width: "160px",
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            cell: (row) => (
                <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    title={bitEdit ? "Editar reporte" : "Sin permiso de edición"}
                    disabled={!bitEdit}
                    onClick={(e) => {
                        e.stopPropagation();
                        onEditReport(row);
                    }}
                >
                    Editar
                </button>
            ),
        },
    ];

    const tableData = {
        columns,
        data,
    };

    /* ------------------ Efecto inicial ------------------ */
    useEffect(() => {
        fetchReportes();
        
    }, []);

    return (
        <>
            {/* Contenedor principal del contenido del modal */}
            <div
                className="p-2 p-sm-3"
                style={{
                    maxHeight: "70vh",
                    overflowY: "auto",
                    width: "100%",
                }}
            >
                {/* Limitamos ancho en desktop para que no se vea tan extendido */}
                <div
                    className="mx-auto"
                    style={{ maxWidth: "900px" }}
                >



                    <div className="card">
                        <div className="card-body p-2 p-sm-3">
                            {/* Wrapper para scroll horizontal en pantallas pequeñas */}
                            <div style={{ width: "100%", overflowX: "auto" }}>
                                <DataTableExtensions
                                    {...tableData}
                                    export={false}
                                    print={false}
                                    defaultSortAsc={true}
                                >
                                    <DataTable
                                        defaultSortField="NombreReporte"
                                        defaultSortAsc={true}
                                        highlightOnHover
                                        pagination
                                        responsive
                                        dense
                                    />
                                </DataTableExtensions>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-2">

                        <button
                            className="btn btn-primary w-100 w-md-auto"
                            onClick={handleNewReportOpen}
                            disabled={!bitInsert}
                            style={{
                                maxWidth: "210px", // limita el tamaño en desktop
                                marginTop: "20px",                                
                            }}
                        >
                            Nuevo reporte
                        </button>
                    </div>
                </div>
            </div>

            {/* Modal interno para crear/editar reporte */}
            <ModalBaseSm
                isOpen={modalEdicionOpen}
                title={idEdit !== -1 ? "Editar Reporte" : "Crear Reporte"}
                onClose={handleCloseModalEdicion}
                childComponent={
                    <FormModalReportePowerBi
                        initialData={idEdit !== -1 ? selectedReporte : {}}
                        idEdit={idEdit}
                        onCancel={handleCloseModalEdicion}
                    />
                }
            />
        </>
    );
};

export default ModalReportesBI;
